// utils/notify.js — fire a toast from ANYWHERE (deeply nested chart cards,
// utility code) without prop-threading showNotification. AppContext listens
// for the event and routes it into the normal notification toast.
// Falls back to alert() only if no provider is mounted (e.g. portal pages).
//
// Usage:  import { notify } from '../utils/notify';
//         notify('Save failed: ' + err.message, 'error');

export const NOTIFY_EVENT = 'epiphany-toast';

let providerMounted = false;
export function _setNotifyProviderMounted(v) { providerMounted = v; }

export function notify(msg, type = 'info') {
  if (providerMounted) {
    window.dispatchEvent(new CustomEvent(NOTIFY_EVENT, { detail: { msg, type } }));
  } else {
    // No toast host available — degrade gracefully rather than swallow errors.
    alert(msg); // eslint-disable-line no-alert
  }
}
